import React from 'react';
import { MapPin, Users, Building2, Award } from 'lucide-react';
import { AnimateOnScroll } from './AnimateOnScroll';
const stats = [{
  id: 1,
  label: 'Estaciones',
  value: '10',
  icon: MapPin,
  desc: 'En toda la región'
}, {
  id: 2,
  label: 'Clientes Satisfechos',
  value: '10,000+',
  icon: Users,
  desc: 'Confiando en nosotros'
}, {
  id: 3,
  label: 'Años de Experiencia',
  value: '25+',
  icon: Building2,
  desc: 'Sirviendo a RD'
}, {
  id: 4,
  label: 'Calidad Garantizada',
  value: '99%',
  icon: Award,
  desc: 'Producto certificado'
}];
export function StatsGrid() {
  return <section className="py-12 sm:py-20 border-b transition-colors duration-300" style={{
    backgroundColor: 'var(--bg-secondary)',
    borderColor: 'var(--border-color)'
  }} data-id="element-419">
      <div className="container mx-auto px-4 sm:px-6 md:px-12" data-id="element-420">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-0 border transition-colors duration-300 rounded-xl overflow-hidden" style={{
        borderColor: 'var(--border-color-strong)'
      }} data-id="element-421">
          {stats.map((stat, index) => <AnimateOnScroll key={stat.id} delay={index * 0.1} direction="up" data-id="element-422">
              <div className={`
                  group relative p-5 sm:p-8 border-b lg:border-b-0
                  ${index !== stats.length - 1 ? 'lg:border-r' : ''}
                  ${index % 2 === 0 ? 'border-r' : ''}
                  transition-colors duration-300
                `} style={{
            backgroundColor: 'var(--bg-primary)',
            borderColor: 'var(--border-color-strong)'
          }} data-id="element-423">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#FCEE02] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-424" />

                <stat.icon className="w-8 h-8 sm:w-10 sm:h-10 text-[#FCEE02] mb-4 sm:mb-6" strokeWidth={1.5} data-id="element-425" />

                <h3 className="text-3xl sm:text-4xl font-black mb-2 tracking-tight transition-colors duration-300" style={{
              color: 'var(--text-primary)'
            }} data-id="element-426">
                  {stat.value}
                </h3>
                <p className="font-bold uppercase tracking-wider text-xs sm:text-sm mb-2" style={{
              color: 'var(--accent-yellow-text)'
            }} data-id="element-427">
                  {stat.label}
                </p>
                <p className="text-xs sm:text-sm transition-colors duration-300" style={{
              color: 'var(--text-muted)'
            }} data-id="element-428">
                  {stat.desc}
                </p>

                <div className="absolute bottom-4 right-4 w-2 h-2 group-hover:bg-[#FCEE02] transition-colors" style={{
              backgroundColor: 'var(--border-color-strong)'
            }} data-id="element-429" />
              </div>
            </AnimateOnScroll>)}
        </div>
      </div>
    </section>;
}